import { render, staticRenderFns } from "./ServicesSticky.vue?vue&type=template&id=da92226c"
import script from "./ServicesSticky.vue?vue&type=script&lang=js"
export * from "./ServicesSticky.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports